import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { disc } from "ionicons/icons";

// Translation resources
const resources = {
  en: {
    translation: {
      mobileFooter: {
        home: "Home",
        community: "Community",
        study: "LoonLearn",
        more: "More",
      },
      canadianNews: "Canadian News",
      noCanadianNews: "No Canadian news available.",
      readMore: "Read more",
      localEvents: "Local Events",
      events: "Events",
      noEventsFound: "No Events Found",
      noEventsFoundContent: "Couldn’t find any events for {{city}} right now.",
      viewEvent: "View Event",
      canadianMarket: "Canadian Market",
      noMarketDataFound: "No Market Data Found",
      noMarketDataFoundContent:
        "Couldn’t fetch TSX or crypto prices right now. Check back soon!",
      Explore: "Explore",
      discover: "Discover",
      following: "Following",
      local: "Local",
      now: "Now",
      news: "News",
      Ride: "Rides",
      poll: "Poll",
      race: "Race",
      media: "Media",
      image: "Image",
      ride: "Rides",
      video: "Video",
      Home: "Home",
      Alerts: "Alerts",
      Messages: "Chat",
      Bookmarks: "Bookmarks",
      Friends: "Loons",
      Profile: "Profile",
      Settings: "Settings",
      Post: "Post",
      AI: "AI",
      Videos: "LoonClips",
      Trending: "Community",
      Edit: "Edit",
      Search: "Search",
      signin: "Sign In",
      usernameOrEmail: "Username or Email",
      password: "Password",
      passwordPlaceholder: "Create a password",
      passwordPlaceholder2: "Password",
      loading: "Loading...",
      signin_button: "Sign in",
      noAccount: "Create new account",
      signup: "Create a LoonLog account",
      CreateA: "Create a",
      account: "Account",
      signup2: "Sign Up",
      YourBirthday: "Your Birthday",
      birthdayPlaceholder: "Enter your birthday",
      inviteCode: "Invite Code",
      inviteCodeLabel: "From LoonLog’s official socials.",
      footerTitle: "You agree to our  ",
      signin2: "Sign in",
      fname: "First name",
      lname: "Last name",
      email: "Email",
      emailPlaceholder: "Enter your email",
      username: "Username",
      usernamePlaceholder: "Choose a username",
      usernamePlaceholder2: "Username or Email",
      confirm: "Confirm password",
      haveAccount: "Do you have an account?",
      replyPlaceholder: "Post your reply",
      replyButton: "Reply",

      PostPlaceholder: "What's happening?",
      PostAdPlaceholder: "What are you selling or offering?",
      PostButton: "Post",
      PostAdButton: "Post Ad",
      postForm: {
        placeholder: "What's on your mind?",
        discussionPlaceholder: "What are your thoughts?",
        discussionBodyPlaceholder: "What's this discussion about?",
        pollPlaceholder: "Ask eh... Polls, Votes or Surveys",
        posting: "Posting...",
        post: "Post",
        discussion: "Discussion",
        reply: "Reply",
        replying: "Replying...",
      },
      editBtn: {
        editProfile: "Edit",
      },
      postPoll: {
        optionPlaceholder: "Option {{number}}",
        addOption: "+ Add Option",
      },
      updateProfileForm: {
        firstName: "First name",
        lastName: "Last name",
        location: "Location",
        website: "Website",
        bio: "Bio",
        save: "Save",
      },
      uploadAvatar: "Upload Avatar",
      uploadBanner: "Upload Banner",
      follow: "Follow",
      message: "Message",
      block: "Block",
      mute: "Block",
      report: "Report",
      More: "More",

      "Local Market": "Market",
      Exams: "Exams",
      Students: "Students",

      postMedia: {
        videoUnsupported: "Your browser does not support the video tag.",
      },
      searchPlaceholder: "Search...",
      trendsTitleBig: "Communities",
      trendsTitle: "Powered by People",
      trendsDesc: "Join the conversation.",
      joined: "Joined",

      followers: "Followers",
      friends: "Friends",
      posts: "Posts",
      post: "Post",
      member: "Loon",
      members: "Loons",
      unfollow: "Unfollow",
      cancel: "Cancel",
      deletePostTitle: "Delete Post?",
      deletePostMessage:
        "This can’t be undone and it will be removed from your profile.",
      delete: "Delete",
      editProfile: "Edit profile",
      signOut: "Logout",
      time: {
        now: "now",
        minute: "m",
        hour: "h",
        day: "d",
        week: "w",
        month: "mo",
        year: "y",
      },
      sidebar: {
        loonlog: "ꪶꪮꪮꪀꪶꪮᧁ",
        home: "Home",
        explore: "Explore",
        videos: "LoonClips",
        market: "Local Market",
        notification: "Alerts",
        message: "Chat",
        bookmark: "Bookmarks",
        friends: "Friends",
        exams: "Exams",
        students: "Students",
        profile: "Profile",
        post: "Post",
      },
      aiPlaceholder: "Message LoonAi",
      aiButtonAsk: "Ask",
      aiLoadingThinking: "Thinking...",
      noBookmarksTitle: "You haven’t added any Posts to your Bookmarks yet",
      noBookmarksSubtitle: "When you do, they’ll show up here.",
      noChatsTitle: "Eh!",
      noChatsSubtitle: "No chats yet.",
      backToMessages: "Back to messages",
      typeAMessage: "Type a message",
      messageInput: "Message input field",
      sendMessage: "Send message",
      notFound: "Not found!",
      explore: {
        noPosts: "No posts yet.",
      },
      hashtag: {
        emptyTitle: "Eh!",
        noPostsWithThisTag: "There are no posts with this hashtag",
      },
      noPostsTitle: "Eh!",
      noPostsText: "No posts yet.",
      replies: "Replies",
      search: {
        users: "Users",
        posts: "Posts",
        noResultsTitle: "Oops!",
        noResultsMessage: "There are no matching posts.",
      },
      settings: {
        pageTitle: "This is a settings page",
      },
      trends: {
        post: "Post",
        posts: "Posts",
        noTrends: "There are no trends",
        trendingIn: "Trending in",
      },
      Travel: "Travel",
      market: "Stock Market",
      market1: "Market",
      rides: "Rides",
      polls: "Polls",
      Students: "Students",
      Exams: "Exams",
      videos: "LoonClips",
      trending: "Community",
      footer: {
        terms: "Terms",
        privacy: "Privacy Policy",
        help: "Help",
        child_safety: "Child Safety",
        about: "About",
      },
      getApp: "Get the app",
      forgotPassword: "Forgot password?",
      localFinds: "Local Finds",
      rideTagLine: "Community focused, flexible, & reliable.",
      comingSoonAI: "Coming soon… Under Development",
      career: "🎓 Career",
      students: "💼 Students",
      typeMessagePlaceholder: "Type a message",
      landingHeader: {
        about: "About",
        terms: "Terms",
        privacy: "Privacy",
        safety: "Safety",
        help: "Help",
        faq: "FAQ",
        blog: "Blog",
      },
      landing: {
        // headlineLine1: "Canada’s Own Social Platform",
        headlineLine1: "Canada’s Community Network",
        headlineLine2Before: "This is",
        headlineBrand: "Canada",
        headlineLine2After: "connected",
        description:
          "Connect with people near you — real communities across Canada.",
        // description:
        //   "With LoonLog, Canadians have one place to connect, learn, share securely, support local, find rides — and belong.",
        register: "Join Now",
        signin: "Sign in",
        subnote: "Free to join. Built proudly in Canada 🍁",
        downloadApp: "Prefer the app? Download it",
        canadianTitle: "Canadian-Owned",
        canadianDesc: "Built here, for Canadians",
        learnTitle: "Learn Together",
        learnDesc: "Group study & exam prep",
        privacyTitle: "LoonLock Privacy",
        privacyDesc: "Encrypted sharing you control",
        finalcta: "Join Canada’s Digital Community",
        heroTagline: {
          main: "Canada's Own Social Platform  — ",
          sub: "This is Canada, Connected",
        },
        heroText2Title: "More Than Social Media",
        heroText2Desc: "ʙᴇʏᴏɴᴅ sᴏᴄɪᴀʟ. ᴛʜɪs ɪs ᴄᴀɴᴀᴅᴀ.",
        cards: {
          card1: {
            title: "Education & Exam Prep",
            subtitle: "Built for Canada",
            desc: "Canadian high school subjects and professional exams — unlimited, including NCLEX-RN.",
          },
          card2: {
            title: "Canada",
            subtitle: "All of Canada, in One Place",
            desc: "Events, news, and the Stock Market across Canada — updated in real time.",
          },
          card3: {
            title: "Community Marketplace",
            subtitle: "Buy & Sell Locally",
            desc: "Buy, sell, and share items within trusted local communities.",
          },
          card4: {
            title: "Community Ride Sharing",
            subtitle: "Rides With People You Trust",
            desc: "Coordinate rides safely with people you know and trust.",
          },
          card5: {
            title: "Secure File Sharing",
            subtitle: "Private by Design",
            desc: "Share documents securely inside groups and communities.",
          },
        },
      },
      signin2: {
        heroTitle: "Canada’s Own Social Platform",
        heroDescription:
          "Built to help Canadians connect, learn, support local — and belong.",
      },
      signup3: {
        heroTitle: "Canada’s Own Social Platform",
        heroDescription: "Join now to connect, learn, and share",
        heroDescription2: "Built for Canadians, by Canadians.",
        features: {
          local: "Support local communities",
          rides: "Find rides and make new friends",
          early: "Get early access to new features",
        },
      },
      footer2: {
        patent: "Patent Pending · CIPO 3292395",
      },
    },
  },
  fr: {
    translation: {
      mobileFooter: {
        home: "Accueil",
        community: "Communauté",
        study: "LoonLearn",
        more: "Plus",
      },
      canadianNews: "Nouvelles canadiennes",
      events: "Événements",
      noCanadianNews: "Aucune nouvelle canadienne disponible.",
      readMore: "Lire la suite",
      localEvents: "Événements locaux",
      noEventsFound: "Aucun événement trouvé",
      noEventsFoundContent:
        "Impossible de trouver des événements pour {{city}} en ce moment.",
      viewEvent: "Voir l'événement",
      canadianMarket: "Marché canadien",
      noMarketDataFound: "Aucune donnée de marché trouvée",
      noMarketDataFoundContent:
        "Impossible de récupérer les prix du TSX ou des cryptomonnaies pour le moment. Revenez bientôt !",
      Explore: "Explorer",
      following: "Abonnements",
      local: "Local",
      now: "Maintenant",
      media: "Médias",
      image: "Image",
      ride: "Covoiturages",
      rides: "Covoiturages",
      news: "Nouvelles",

      poll: "Sondage",
      polls: "Sondages",
      race: "Course",
      video: "Vidéo",
      Home: "Accueil",
      Alerts: "Alertes",
      Messages: "Chat",
      Bookmarks: "Favoris",
      Friends: "Loons",
      Profile: "Profil",
      Settings: "Paramètres",
      Post: "Publication",
      AI: "IA",
      Videos: "Vidéos",
      Trending: "Communauté",
      Edit: "Modifier",
      Search: "Recherche",
      discover: "Découvrir",
      signin: "Connexion à",
      usernameOrEmail: "Nom d'utilisateur ou e-mail",
      password: "Mot de passe",
      passwordPlaceholder: "Créez un mot de passe",
      passwordPlaceholder2: "Entrez votre mot de passe",
      loading: "Chargement...",
      signin_button: "Se connecter",
      noAccount: "Créer un nouveau compte",
      forgotPassword: "Mot de passe oublié?",
      signup: "S'inscrire",
      signup2: "S'inscrire",

      YourBirthday: "Votre date de naissance",
      birthdayPlaceholder: "Entrez votre date de naissance",
      inviteCode: "Code d'invitation",
      inviteCodeLabel: "Voir les réseaux officiels LoonLog pour le code.",
      footerTitle: "En créant un compte, vous acceptez nos",
      signin2: "Se connecter",
      CreateA: "Créer un",
      account: "Compte",
      trending: "Tendances",
      polls: "Sondages",
      videos: "LoonClips",
      fname: "Prénom",
      lname: "Nom de famille",
      email: "E-mail",
      emailPlaceholder: "Entrez votre adresse courriel",
      username: "Nom d'utilisateur",
      usernamePlaceholder: "Choisissez un nom d’utilisateur",
      usernamePlaceholder2: "Nom d’utilisateur ou e-mail",
      confirm: "Confirmez le mot de passe",
      haveAccount: "Vous avez déjà un compte ?",
      replyPlaceholder: "Publiez votre réponse",
      replyButton: "Répondre",

      PostPlaceholder: "Que se passe-t-il ?",
      PostAdPlaceholder: "Que vendez-vous ou proposez-vous ?",
      PostButton: "Publier",
      PostAdButton: "Publier une annonce",

      postForm: {
        placeholder: "À quoi pensez-vous ?",
        discussionPlaceholder: "Qu'en pensez-vous ?",
        discussionBodyPlaceholder: "De quoi parle cette discussion ?",
        pollPlaceholder: "Posez une question... Sondages, Votes ou Enquêtes",
        posting: "Publication en cours...",
        post: "Publier",
        discussion: "Discussion",
        reply: "Répondre",
        replying: "Répondre...",
      },
      editBtn: {
        editProfile: "Modifier",
      },
      postPoll: {
        optionPlaceholder: "Option {{number}}",
        addOption: "+ Ajouter une option",
      },

      updateProfileForm: {
        firstName: "Prénom",
        lastName: "Nom de famille",
        location: "Localisation",
        website: "Site web",
        bio: "Biographie",
        save: "Enregistrer",
      },
      uploadAvatar: "Télécharger l'avatar",
      uploadBanner: "Télécharger la bannière",
      follow: "Suivre",

      message: "Message",
      block: "Block",
      mute: "Mute",
      report: "Report",
      More: "Plus",

      LocalMarket: "Marché local",
      market: "Marché boursier",
      market1: "Marché",
      localFinds: "Découvertes locales",
      Exams: "Examens",
      Students: "Étudiants",

      postMedia: {
        videoUnsupported:
          "Votre navigateur ne prend pas en charge la balise vidéo.",
      },

      searchPlaceholder: "Rechercher...",
      trendsTitleBig: "Communautaires",
      trendsTitle: "Animées par vous",
      trendsDesc: "Rejoignez la conversation.",
      joined: "Inscrit",
      "Local Market": "Market",
      followers: "Abonnés",
      friends: "Amis",
      posts: "Publications",
      member: "Membre",
      members: "Membres",
      post: "Publication",
      unfollow: "Se désabonner",
      cancel: "Annuler",
      deletePostTitle: "Supprimer la publication ?",
      deletePostMessage:
        "Cette action est irréversible. Elle supprimera cette publication de votre profil.",
      delete: "Supprimer",
      editProfile: "Modifier le profil",
      signOut: "Se déconnecter",
      time: {
        now: "maintenant",
        minute: "min",
        hour: "h",
        day: "j",
        week: "sem",
        month: "mois",
        year: "an",
      },
      sidebar: {
        loonlog: "ꪶꪮꪮꪀꪶꪮᧁ",
        home: "Accueil",
        explore: "Explorer",
        videos: "Vidéos",
        market: "Marché Local",
        notification: "Alertes",
        message: "Messages",
        bookmark: "Signets",
        friends: "Amis",
        exams: "Examens",
        students: "Étudiants",
        profile: "Profil",
        post: "Publier",
      },
      aiPlaceholder: "Message LoonAi",
      aiButtonAsk: "Demander",
      aiLoadingThinking: "Réflexion en cours...",
      noBookmarksTitle:
        "Vous n'avez pas encore ajouté de publications à vos favoris",
      noBookmarksSubtitle: "Quand vous le ferez, elles apparaîtront ici.",

      noChatsTitle: "Hé !",
      noChatsSubtitle: "Pas encore de discussions.",
      backToMessages: "Retour aux messages",
      typeAMessage: "Tapez un message",
      messageInput: "Champ de saisie du message",
      sendMessage: "Envoyer le message",
      notFound: "Introuvable !",
      explore: {
        noPosts: "Pas encore de publications.",
      },
      hashtag: {
        emptyTitle: "Oh là là !",
        noPostsWithThisTag: "Il n'y a aucune publication avec ce hashtag",
      },
      noPostsTitle: "Oh là là !",
      noPostsText: "Pas encore de publications.",
      replies: "Réponses",
      search: {
        users: "Users",
        posts: "Posts",
        noResultsTitle: "Oups !",
        noResultsMessage: "Aucun post correspondant.",
      },
      settings: {
        pageTitle: "Ceci est une page de paramètres",
      },
      trends: {
        post: "Publication",
        posts: "Publications",
        noTrends: "Il n’y a pas de tendances",
        trendingIn: "Tendance au",
      },
      Travel: "Voyage",
      footer: {
        terms: "Termes",
        privacy: "Confidentialité",
        help: "Aide",
        child_safety: "Sécurité des enfants",
        about: "À propos de",
      },
      getApp: "Télécharger l'application",
      rideTagLine: "Axé sur la communauté, flexible et fiable.",
      comingSoonAI: "Bientôt disponible... En cours de développement",
      career: "🎓 Carrière",
      students: "💼 Étudiants",
      typeMessagePlaceholder: "Tapez un message",
      landingHeader: {
        about: "À propos",
        terms: "Conditions",
        privacy: "Confidentialité",
        safety: "Sécurité",
        help: "Aide",
        faq: "FAQ",
        blog: "Blogue",
      },
      landing: {
        headlineLine1: "Le réseau communautaire du Canada",
        headlineLine2Before: "Voici",
        headlineBrand: "le Canada",
        headlineLine2After: "connecté",
        description:
          "Connectez avec des gens près de chez vous — de vraies communautés partout au Canada.",
        register: "S’inscrire",
        signin: "Se connecter",
        subnote: "Inscription gratuite. Fièrement conçu au Canada 🍁",
        downloadApp: "Vous préférez l’application? Téléchargez-la",
        canadianTitle: "Entreprise canadienne",
        canadianDesc: "Conçu ici, pour les Canadiens",
        learnTitle: "Apprendre ensemble",
        learnDesc: "Étude de groupe et préparation aux examens",
        privacyTitle: "Confidentialité LoonLock",
        privacyDesc: "Partage chiffré sous votre contrôle",
        finalcta: "Joignez-vous à la communauté numérique du Canada",
        heroTagline: {
          main: "La propre plateforme sociale du Canada — ",
          sub: "Le Canada, branché",
        },
        heroText2Title: "Plus qu’un média social",
        heroText2Desc: "ᴀᴜ-ᴅᴇʟà ᴅᴜ sᴏᴄɪᴀʟ. ᴠᴏɪᴄɪ ʟᴇ ᴄᴀɴᴀᴅᴀ.",
        cards: {
          card1: {
            title: "Éducation et préparation aux examens",
            subtitle: "Conçu pour le Canada",
            desc: "Matières du secondaire canadien et examens professionnels — illimité, incluant le NCLEX-RN.",
          },
          card2: {
            title: "Canada",
            subtitle: "Tout le Canada, en un seul endroit",
            desc: "Événements, nouvelles et Bourse à travers le Canada — mis à jour en temps réel.",
          },
          card3: {
            title: "Marché communautaire",
            subtitle: "Achetez et vendez localement",
            desc: "Achetez, vendez et partagez des articles au sein de communautés locales de confiance.",
          },
          card4: {
            title: "Covoiturage communautaire",
            subtitle: "Des trajets avec des gens de confiance",
            desc: "Coordonnez vos déplacements en toute sécurité avec des personnes que vous connaissez et en qui vous avez confiance.",
          },
          card5: {
            title: "Partage de fichiers sécurisé",
            subtitle: "Privé par conception",
            desc: "Partagez des documents en toute sécurité au sein de vos groupes et communautés.",
          },
        },
      },
      signin2: {
        heroTitle: "La plateforme sociale du Canada",
        heroDescription:
          "Conçue pour aider les Canadiens à se connecter, apprendre, soutenir le local — et se sentir chez eux.",
      },
      signup3: {
        heroTitle: "La plateforme sociale du Canada",
        heroDescription:
          "Joignez-vous dès maintenant pour vous connecter, apprendre et partager",
        heroDescription2: "Conçue par des Canadiens, pour les Canadiens.",
        features: {
          local: "Soutenez les communautés locales",
          rides: "Trouvez des covoiturages et faites de nouvelles rencontres",
          early: "Accédez en primeur aux nouvelles fonctionnalités",
        },
      },
      footer2: {
        patent: "Brevet en instance · CIPO 3292395",
      },
    },
  },
};

i18n
  .use(LanguageDetector) // Automatically detects language
  .use(initReactI18next) // Connects with React
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "fr"],
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
    resources,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
